import type { Kanaal } from "../api";

/**
 * Sessie 70 (punt 13): noemt JP in zijn vraag een kanaal ("zet dit klaar
 * als mail", "stuur het per WhatsApp")? Dan gaat het concept met dat
 * kanaal naar het antwoordvak, dat erheen wisselt als het aan staat.
 * Zonder kanaal in de vraag: null, de tekst gaat in het open kanaal.
 *
 * Alleen een opdracht telt ("zet", "stuur", "schrijf", ...): "wat zei de
 * klant op WhatsApp" of "hij wil het per mail" is een vraag, geen wissel.
 * Een ontkenning ("niet via WhatsApp maar per mail") slaat dat kanaal over.
 */
const KANAAL_WOORD: [Kanaal, string][] = [
  ["whatsapp", "whats ?app(?:je|bericht)?"],
  ["mail", "e-?mail(?:tje)?|mailtje|mail"],
  ["chat", "chat(?:bericht)?"],
];
const OPDRACHT = /\b(zet|stuur|verstuur|schrijf|maak|antwoord|reageer|beantwoord)\b/i;

export function kanaalUitVraag(vraag: string): Kanaal | null {
  // "Mail het maar": mailen als werkwoord is zelf de opdracht.
  if (/^\s*mail\s+(?:het|dit|hem|haar)\b/i.test(vraag)) return "mail";
  if (!OPDRACHT.test(vraag)) return null;
  let beste: { kanaal: Kanaal; plek: number } | null = null;
  for (const [kanaal, woord] of KANAAL_WOORD) {
    const patroon = new RegExp(
      `(\\bniet\\s+(?:meer\\s+)?)?\\b(?:(?:als|per|via|in|naar|op)\\s+(?:een\\s+|de\\s+)?|een\\s+)(?:${woord})\\b`,
      "gi",
    );
    for (const treffer of vraag.matchAll(patroon)) {
      if (treffer[1]) continue;
      const plek = treffer.index ?? 0;
      if (!beste || plek < beste.plek) beste = { kanaal, plek };
    }
  }
  if (beste) return beste.kanaal;
  return /\bmail\s+(?:het|dit|hem|haar)\b/i.test(vraag) ? "mail" : null;
}
